module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Ge-Ha-Ic-Ja.9ed8a843.png";